import { TABLA_CODIGO_DE_CUPOS } from '../../../../../config/tables'
import { CodigoDeCupo } from '../../../../../models/cupo/codigoDeCupo'
import { pdfCustomToolbarGenerator } from '../../../../../models/tools/generarPdf'
import { getColumnasCodigosDeCupo, COLUMNS_CODIGO_DE_CUPOS_TO_PRINT, CODIGO_DE_CUPOS_EXTERNOS_TO_PRINT } from './constantesConsultaCodigoDeCupos'

export function parseData (data) {
  const parsedData = []
  if (data) {
    for (const entry of data) {
      let estado
      if (entry.arribo) {
        estado = entry.arribo
      } else if ((entry.estadoCupoStopq === '') && !entry.estadoCupoStopq.startsWith('Consum')) {
        estado = 'Sin consumir'
      } else if (entry.estadoCupoStopq === 'Bloqueado') {
        estado = 'Bloqueado'
      }
      const dataCTG = {
        estado: estado,
        estadoCupoStopq: entry.estadoCupoStopq
      }
      entry.estado = estado
      parsedData.push({ ...entry, estado: estado, dataCTG: dataCTG, entry: entry })
    }
  }
  return parsedData
}

export function obtenerCodigosDeCupos (funct, fechaDesde, fechaHasta, cereal, arribo, filtroInicial, rol, columnasToPrint) {
  return dispatch => {
    dispatch({ type: 'RESET_CODIGOS_DE_CUPO' })
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CODIGO_DE_CUPOS
    })

    funct(fechaDesde, fechaHasta, cereal, arribo).then(callback)
    function callback (d) {
      const data = parseData(d)
      dispatch({ type: 'OBTENER_CODIGOS_DE_CUPO', data })
      const textRowCount = 'Cantidad: '
      const columnas = getColumnasCodigosDeCupo(rol)
      const customToolbar = pdfCustomToolbarGenerator(
        'Códigos de cupo',
        data,
        columnasToPrint,
        'landscape')
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: columnas,
          data: data,
          title: `Códigos de cupo`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: {
            customToolbar,
            print: false,
            pagination: false,
            tableBodyMaxHeight: '499px',
            showRowCount: true,
            textRowCount,
            filtroInicial
          }
        },
        id: TABLA_CODIGO_DE_CUPOS
      })
    }
  }
}

export function cargarCodigosDeCupos (d, filtroInicial, rol, columnasToPrint) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CODIGO_DE_CUPOS
    })
    const data = parseData(d)
    const textRowCount = 'Cantidad: '
    const columnas = getColumnasCodigosDeCupo(rol)
    const customToolbar = pdfCustomToolbarGenerator(
      'Códigos de cupo',
      data,
      columnasToPrint,
      'landscape')
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        columns: columnas,
        data: data,
        title: `Códigos de cupo`,
        isLoading: false,
        fixed2Decimales: false,
        extraOptions: {
          customToolbar,
          print: false,
          pagination: false,
          tableBodyMaxHeight: '499px',
          showRowCount: true,
          textRowCount,
          filtroInicial
        }
      },
      id: TABLA_CODIGO_DE_CUPOS
    })
  }
}

export function actualizarDatosParaMuiTable (fechaD, fechaH, roles, cereal = null, arribo = null, filtroInicial = null) {
  return (dispatch, getState) => {
    // Si es rol externo va con otra consulta, ya que tiene habilitado para obtener
    // los codigos de un rango de fechas y la completa demora bastante.
    const rol = roles.filter(roles => roles === 'EXPORTADOR' || roles === 'CARGADOR' || roles === 'CORREDOR')
    const rolExterno = rol.length > 0
    const state = getState()

    const funct = rolExterno ? CodigoDeCupo.getCodigosDeCupo : CodigoDeCupo.getDataTablaConsultaCodigoDeCuposFiltrada
    const columnasToPrint = rolExterno ? CODIGO_DE_CUPOS_EXTERNOS_TO_PRINT : COLUMNS_CODIGO_DE_CUPOS_TO_PRINT

    const codigosDeCupo = state.dashboard.codigosDeCupo || null

    if (codigosDeCupo && codigosDeCupo.length > 0 && cereal) {
      const unDia = fechaD === fechaH
      let d = codigosDeCupo
      d = d.filter((c) => c.cereal === cereal)
      if (arribo) { d = d.filter((c) => c.arribo === arribo) }
      if (unDia) { d = d.filter((c) => c.fechaCupo === fechaD) }

      dispatch(cargarCodigosDeCupos(d, filtroInicial, rol, columnasToPrint))
    } else {
      return dispatch(obtenerCodigosDeCupos(
        funct,
        fechaD,
        fechaH,
        cereal,
        arribo,
        filtroInicial,
        rol,
        columnasToPrint
      ))
    }
  }
}
